'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosCalculatorOutline = function IoIosCalculatorOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm11 12.5v-5h17.5v5h-17.5z m1.3-3.7v2.5h15v-2.5h-15z m16.2-3.8c1.4 0 2.5 1.1 2.5 2.5v25c0 1.4-1.1 2.5-2.5 2.5h-17.5c-1.4 0-2.5-1.1-2.5-2.5v-25c0-1.4 1.1-2.5 2.5-2.5h17.5z m1.3 27.5v-25c0-0.7-0.6-1.2-1.3-1.2h-17.5c-0.7 0-1.2 0.5-1.2 1.2v25c0 0.7 0.5 1.3 1.2 1.3h17.5c0.7 0 1.3-0.6 1.3-1.3z m-17.5-13.7h3.7v1.2h-5v-5h1.3v3.8z m0 6.2h3.7v1.3h-5v-5h1.3v3.7z m0 6.3h3.7v1.2h-5v-5h1.3v3.8z m6.2-12.5h3.8v1.2h-5v-5h1.2v3.8z m6.3 0h3.7v1.2h-5v-5h1.3v3.8z m-6.3 6.2h3.8v1.3h-5v-5h1.2v3.7z m0 6.3h3.8v1.2h-5v-5h1.2v3.8z m6.3 0h3.7v1.2h-5v-11.2h1.3v10z' })
        )
    );
};

exports.default = IoIosCalculatorOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-calculator-outline.js
// module id = 2097
// module chunks = 0